import React, { useState } from 'react';

const MONEDAS = {
  USD: { simbolo: '$',   nombre: 'USD — Dólar estadounidense', bandera: '🇺🇸', tasa: 1,     dec: 0 },
  ARS: { simbolo: '$',   nombre: 'ARS — Peso argentino',       bandera: '🇦🇷', tasa: 1250,  dec: 0 },
  BRL: { simbolo: 'R$',  nombre: 'BRL — Real brasileño',       bandera: '🇧🇷', tasa: 5.70,  dec: 2 },
  MXN: { simbolo: '$',   nombre: 'MXN — Peso mexicano',        bandera: '🇲🇽', tasa: 17.5,  dec: 0 },
  COP: { simbolo: '$',   nombre: 'COP — Peso colombiano',      bandera: '🇨🇴', tasa: 4100,  dec: 0 },
  CLP: { simbolo: '$',   nombre: 'CLP — Peso chileno',         bandera: '🇨🇱', tasa: 960,   dec: 0 },
  PEN: { simbolo: 'S/',  nombre: 'PEN — Sol peruano',          bandera: '🇵🇪', tasa: 3.75,  dec: 2 },
  UYU: { simbolo: '$',   nombre: 'UYU — Peso uruguayo',        bandera: '🇺🇾', tasa: 43,    dec: 0 },
  BOB: { simbolo: 'Bs.', nombre: 'BOB — Boliviano',            bandera: '🇧🇴', tasa: 6.9,   dec: 2 },
  PYG: { simbolo: '₲',   nombre: 'PYG — Guaraní paraguayo',   bandera: '🇵🇾', tasa: 7500,  dec: 0 },
  EUR: { simbolo: '€',   nombre: 'EUR — Euro',                 bandera: '🇪🇺', tasa: 0.92,  dec: 2 },
};

const PLAN = {
  id: 'basico',
  nombre: 'Mi Estudio',
  precio_usd: 10,
  precio_ars: 13000,
  desc: 'Todo lo que necesitás para llevar tu estudio.',
  features: ['1 estudio, 1 colaborador incluido', 'Expedientes y trámites extrajudiciales ilimitados', 'Agenda con alertas de vencimientos', 'Gestión de clientes', 'Sistema de asignación de tareas', 'Contabilidad de tu estudio'],
};

function formatPrecio(usd, moneda) {
  const m = MONEDAS[moneda];
  const valor = usd * m.tasa;
  return `${m.simbolo}${valor.toLocaleString('es-AR', { minimumFractionDigits: m.dec, maximumFractionDigits: m.dec })}`;
}

export default function Pago({ perfil, suscripcion }) {
  const [loadingPlan, setLoadingPlan] = useState(null);
  const [error, setError] = useState('');
  const [moneda, setMoneda] = useState('USD');
  const [selectorOpen, setSelectorOpen] = useState(false);

  const trialExpirado = suscripcion?.estado === 'trial'
    && suscripcion?.trial_hasta
    && new Date(suscripcion.trial_hasta) < new Date();

  async function pagar(plan, provider) {
    setLoadingPlan(`${plan}-${provider}`);
    setError('');
    try {
      const res = await fetch('/api/crear-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          provider,
          plan,
          estudio_id: perfil?.estudio_activo_id,
          user_email: perfil?.email,
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError(data.error || 'Error al crear el checkout. Intentá de nuevo.');
        setLoadingPlan(null);
      }
    } catch {
      setError('Error de conexión. Intentá de nuevo.');
      setLoadingPlan(null);
    }
  }

  const m = MONEDAS[moneda];

  return (
    <div style={{ padding: '40px 24px', maxWidth: 960, margin: '0 auto' }}>

      {/* Header con selector de moneda */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 32, flexWrap: 'wrap', gap: 16 }}>
        <div>
          {trialExpirado ? (
            <div style={{ fontSize: 13, color: '#dc2626', fontWeight: 600, background: '#fee2e2', display: 'inline-block', padding: '5px 16px', borderRadius: 20, marginBottom: 12 }}>
              Tu período de prueba ha terminado
            </div>
          ) : (
            <div style={{ fontSize: 13, color: '#16a34a', fontWeight: 600, background: '#dcfce7', display: 'inline-block', padding: '5px 16px', borderRadius: 20, marginBottom: 12 }}>
              Suscripción
            </div>
          )}
          <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text)', margin: '0 0 4px' }}>
            {trialExpirado ? 'Activá tu suscripción para continuar' : 'Tu suscripción'}
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text4)', margin: 0 }}>
            Acceso completo · Cancelás cuando querés
          </p>
        </div>

        {/* Selector de moneda */}
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <button
            onClick={() => setSelectorOpen(o => !o)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600,
              color: 'var(--text)', cursor: 'pointer', minWidth: 160,
            }}
          >
            <span style={{ fontSize: 16 }}>{m.bandera}</span>
            <span>{moneda}</span>
            <span style={{ marginLeft: 'auto', fontSize: 10, color: 'var(--text4)' }}>▼</span>
          </button>

          {selectorOpen && (
            <div style={{
              position: 'absolute', top: '100%', right: 0, marginTop: 4,
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              zIndex: 100, minWidth: 240, overflow: 'hidden',
            }}>
              {Object.entries(MONEDAS).map(([code, info]) => (
                <button
                  key={code}
                  onClick={() => { setMoneda(code); setSelectorOpen(false); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    width: '100%', padding: '10px 14px', border: 'none',
                    background: code === moneda ? 'var(--accent-light, #eff6ff)' : 'transparent',
                    cursor: 'pointer', fontSize: 13, color: 'var(--text)',
                    textAlign: 'left', fontWeight: code === moneda ? 600 : 400,
                  }}
                >
                  <span style={{ fontSize: 18 }}>{info.bandera}</span>
                  <span>{info.nombre}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {error && (
        <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', color: '#dc2626', borderRadius: 8, padding: '12px 16px', fontSize: 13, marginBottom: 24, textAlign: 'center' }}>
          {error}
        </div>
      )}

      <div style={{ maxWidth: 380, margin: '0 auto' }}>
        <div style={{
          background: 'var(--surface)',
          border: '2px solid #2563eb',
          borderRadius: 14, padding: '28px 22px',
          position: 'relative', display: 'flex', flexDirection: 'column',
        }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)', marginBottom: 3 }}>{PLAN.nombre}</div>
          <div style={{ fontSize: 12, color: 'var(--text4)', marginBottom: 16 }}>{PLAN.desc}</div>
          <div style={{ marginBottom: 4 }}>
            <span style={{ fontSize: 30, fontWeight: 800, color: 'var(--text)' }}>
              {formatPrecio(PLAN.precio_usd, moneda)}
            </span>
            <span style={{ fontSize: 13, color: 'var(--text4)' }}> {moneda}/mes</span>
          </div>
          {moneda !== 'USD' && (
            <div style={{ fontSize: 11, color: 'var(--text4)', marginBottom: 16 }}>
              ≈ ${PLAN.precio_usd} USD · precio referencial
            </div>
          )}
          {moneda === 'USD' && <div style={{ marginBottom: 16 }} />}
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px', flex: 1, display: 'flex', flexDirection: 'column', gap: 7 }}>
            {PLAN.features.map(f => (
              <li key={f} style={{ fontSize: 12, color: 'var(--text2)', display: 'flex', alignItems: 'flex-start', gap: 7 }}>
                <span style={{ color: '#16a34a', fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
                {f}
              </li>
            ))}
          </ul>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <button
              onClick={() => pagar(PLAN.id, 'mercadopago')}
              disabled={!!loadingPlan}
              style={{
                background: '#009ee3', color: 'white', border: 'none', borderRadius: 8,
                padding: '10px 16px', fontSize: 12, fontWeight: 600,
                cursor: loadingPlan ? 'not-allowed' : 'pointer',
                opacity: loadingPlan === `${PLAN.id}-mercadopago` ? 0.7 : 1,
              }}
            >
              {loadingPlan === `${PLAN.id}-mercadopago` ? 'Redirigiendo...' : 'Pagar con Mercado Pago'}
            </button>
            <button
              onClick={() => pagar(PLAN.id, 'paddle')}
              disabled={!!loadingPlan}
              style={{
                background: '#0c0d21', color: 'white', border: 'none', borderRadius: 8,
                padding: '10px 16px', fontSize: 12, fontWeight: 600,
                cursor: loadingPlan ? 'not-allowed' : 'pointer',
                opacity: loadingPlan === `${PLAN.id}-paddle` ? 0.7 : 1,
              }}
            >
              {loadingPlan === `${PLAN.id}-paddle` ? 'Redirigiendo...' : 'Tarjeta internacional (USD)'}
            </button>
          </div>
        </div>
      </div>

      <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--text4)', marginTop: 28, lineHeight: 1.7 }}>
        Pagos procesados por Mercado Pago y Paddle · Los precios se muestran en {moneda} como referencia.<br/>
        El cobro se realiza en ARS (Mercado Pago) o USD (tarjeta internacional).
      </p>
    </div>
  );
}
